export function resolveStoragePublicUrl(
  path: string,
  baseUrl: string | null | undefined
) {
  if (!path || /^https?:\/\//u.test(path) || !baseUrl) {
    return path;
  }
  const encodedPath = path
    .replace(/^\/+/, '')
    .split('/')
    .map(encodeURIComponent)
    .join('/');
  return `${baseUrl.replace(/\/$/u, '')}/${encodedPath}`;
}
